import { keyframes } from "styled-components";

const RollWidthFromTop = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export default RollWidthFromTop;
